export interface HighlighterColorCacheTagType {
    type: 'HighlighterColor';
    id: 'LIST' | number;
}

export const HighlighterColorCacheTag: HighlighterColorCacheTagType = {
    type: 'HighlighterColor',
    id: 'LIST',
};
